"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _works = require("@/api/works/works");
var _majorType = require("@/api/project/majorType");
var _player = require("@/api/player/player");
var _uploadWorks = _interopRequireDefault(require("@/components/uploadWorks/uploadWorks.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isNeedSave: true,
      xuanshou: true,
      worksId: this.$route.query.worksId,
      worksModel: {
        stageId: this.$route.query.stageId,
        groupId: this.$route.query.groupId,
        matchId: this.$route.query.matchId,
        matchWorksContentParamList: [],
        workName: "",
        majorId: "",
        userId: "",
        userName: ""
      },
      majorList: [],
      submitForm: [],
      showContentSettingtList: [],
      playerList: [],
      isName: false
    };
  },
  filters: {
    getStatus: function getStatus(status) {
      if (status == 1) {
        return "待审核";
      }
      if (status == 2) {
        return "审核未通过";
      }
      if (status == 3) {
        return "待分配";
      }
      if (status == 4) {
        return "评审中";
      }
      if (status == 5) {
        return "结束";
      }
    }
  },
  created: function created() {
    this.getMajorList();
    this.getContentSettingtList();
    this.getSchoolPlayer();
  },
  components: {
    UploadWorks: _uploadWorks.default
  },
  methods: {
    // 获取学校下未分配选手
    getSchoolPlayer: function getSchoolPlayer() {
      var _this = this;
      (0, _player.noMatchPlayer)({
        groupId: this.$route.query.groupId,
        stageId: this.$route.query.stageId
      }).then(function (res) {
        console.log(res, "未分配选手");
        _this.playerList = res.data;
      });
    },
    getMajorList: function getMajorList() {
      var _this2 = this;
      (0, _majorType.getMatchMajorListAll)().then(function (res) {
        _this2.majorList = res.data;
      });
    },
    echoInfo: function echoInfo(id) {
      var _this3 = this;
      (0, _works.getWorksById)({
        id: this.$route.query.id
      }).then(function (res) {
        var resultData = JSON.parse(JSON.stringify(res.data));
        _this3.worksModel.workName = resultData.workName;
        _this3.worksModel.majorId = resultData.majorId;
        _this3.worksModel.id = resultData.id;
        _this3.worksModel.userId = resultData.userId;
        console.log(_this3.worksModel, "wks");
        if (_this3.worksModel.userId != "") {
          _this3.xuanshou = false;
        }
        _this3.worksModel.userName = resultData.userName;
        _this3.worksModel.matchWorksContentParamList = resultData.matchWorkContentListVoList;
        var listContent = JSON.parse(JSON.stringify(_this3.worksModel.matchWorksContentParamList));
        if (resultData.status != 0 && resultData.status != 2) {
          _this3.isNeedSave = false;
        }
        for (var i in _this3.showContentSettingtList) {
          if (listContent.length > 0) {
            for (var k in listContent) {
              if (_this3.showContentSettingtList[i].id == listContent[k].contentId) {
                listContent[k].stageId = _this3.stageId;
                _this3.$set(_this3.worksModel.matchWorksContentParamList, i, listContent[k]);
              }
            }
          } else {
            var emptyListContent = {
              content: "",
              contentFileType: "",
              contentId: "",
              contentName: "",
              id: "",
              viewUrl: "",
              worksId: "",
              stageId: ""
            };
            _this3.$set(_this3.worksModel.matchWorksContentParamList, i, emptyListContent);
          }
        }
        console.log(" this.worksModel.matchWorksContentParamList", _this3.worksModel.matchWorksContentParamList);
      });
    },
    getContentSettingtList: function getContentSettingtList() {
      var _this4 = this;
      (0, _player.getMatchWorksRule)({
        stageId: this.$route.query.stageId,
        groupId: this.$route.query.groupId,
        matchId: this.$route.query.matchId
      }).then(function (res) {
        _this4.showContentSettingtList = res.data;
        for (var k in _this4.showContentSettingtList) {
          _this4.worksModel.matchWorksContentParamList.push({
            id: "",
            worksId: "",
            contentId: _this4.showContentSettingtList[k].id,
            contentName: _this4.showContentSettingtList[k].name,
            content: "",
            viewUrl: "",
            contentFileType: _this4.showContentSettingtList[k].fileType
          });
        }
        if (_this4.$route.query && _this4.$route.query.id) {
          _this4.echoInfo(_this4.$route.query.id);
        }
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getUploadData: function getUploadData(data, contentid, idx, fileType) {
      if (data.ossGenUrl.indexOf("png") > 0 || data.ossGenUrl.indexOf("jpg") > 0 || data.ossGenUrl.indexOf("jpeg") > 0) {
        console.log("fileType", fileType);
        this.worksModel.matchWorksContentParamList[idx].viewUrl = data.ossOriUrl;
      } else {
        this.worksModel.matchWorksContentParamList[idx].viewUrl = data.ossGenUrl + "/thumbnail.png?x-oss-process=image/resize,m_fixed,w_220,h_165,limit_0";
      }
      this.worksModel.matchWorksContentParamList[idx].contentId = contentid;
      this.worksModel.matchWorksContentParamList[idx].content = data.ossOriUrl;
      this.worksModel.matchWorksContentParamList[idx].uploadFileParam = data;
      this.worksModel.matchWorksContentParamList[idx].contentFileType = fileType;
      this.worksModel.matchWorksContentParamList[idx].stageId = this.stageId;
      this.$message.success("上传成功。");
    },
    submitWork: function submitWork(status) {
      var _this5 = this;
      if (this.worksModel.workName == "") {
        this.$message({
          message: "请输入参赛作品/课程名称",
          type: "warning"
        });
        return false;
      }
      if (this.worksModel.majorId == "") {
        this.$message({
          message: "请选择专业大类",
          type: "warning"
        });
        return false;
      }
      this.worksModel.status = status;
      if (status == 1) {
        this.$confirm("确定保存并提交作品？保存提交后作品将不可更改", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this5.insertOrUpdate();
        }).catch(function () {
          _this5.$message({
            message: "已取消",
            type: "info"
          });
        });
      } else {
        this.insertOrUpdate();
      }
    },
    insertOrUpdate: function insertOrUpdate() {
      var _this6 = this;
      (0, _player.insertOrUpdateMatchWorks)(_objectSpread({}, this.worksModel)).then(function (res) {
        if (res.code == 2000) {
          _this6.$message({
            message: "提交成功",
            type: "success"
          });
          _this6.$router.go(-1);
        } else {
          _this6.$message({
            message: "提交失败",
            type: "error"
          });
        }
      });
    }
  },
  watch: {
    "worksModel.userId": {
      handler: function handler(val) {
        if (val !== "") {
          this.isName = true;
          this.worksModel.userName = "";
        } else {
          this.isName = false;
        }
      }
    }
  }
};